<template>
  <div class="pc-page">
    <div class="test_main test_main_3">
      <Nav></Nav>
      <div class="test_detail test_3">
        <div class="box">
          <em class="icon part_over"></em>
          <p class="tips">学习效力测评已完成！</p>
          <div class="btngroup">
            <a class="btn btn_goon" v-if="type!='test'" @click="jump()">点击继续</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Nav from '../../../../components/learningAbility/learningEffectiveness.vue';
  export default {
    data() {
      return {
        testType: ''
      }
    },
    mounted() {
      $('.test_menu .item').eq(2).addClass('item_2');
      this.testType = sessionStorage.getItem('testType');
    },
    updated() {

    },
    methods: {
        jump() {
            this.$router.push('/learningAbility/Navgation4')
        }
    },
    components: {Nav},
  }
</script>

<style>
  .evalu-nav {
    background: #333;
    opacity: 1;
  }
</style>
